import { BinaryQuestionTemplate } from '@templates';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { EmailConfirmationReportOptionsSchema } from '@shared/schemas';
import { parseZodErrors } from '@utils';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';

const pageTitle = 'Do you want a confirmation email of your report?';
const description = `We can send an email to confirm that we've received your report.`;

export const EmailConfirmationReport = () => {
  const { data, get, update } = usePlanningBreachStore();
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  const options = [
    {
      labelText: 'Yes',
      isDefault: data?.receiveConfirmationEmail === 'Yes',
    },
    {
      labelText: 'No',
      isDefault: data?.receiveConfirmationEmail === 'No',
    },
  ];

  const handleChange = (value: string) => {
    update('receiveConfirmationEmail', value);
    setErrorMessages([]);
  };

  const handleNext = () => {
    try {
      const receiveConfirmationEmail = get('receiveConfirmationEmail');
      EmailConfirmationReportOptionsSchema.parse({
        canWeEmailYou: receiveConfirmationEmail,
      });
      navigate(RoutesList.CONTACT_USER_OPTION);
    } catch (error) {
      const validationErrors = parseZodErrors(error as ZodError);
      setErrorMessages(
        validationErrors.map((error: ErrorMessages) => ({
          ...error,
          href: error.path,
        })),
      );
    }
  };

  const buttonNext = {
    label: 'Next',
    onClick: handleNext,
  };

  const buttonPrevious = {
    onClick: () => navigate(RoutesList.ANY_MORE_INFO),
  };

  return (
    <>
      <BinaryQuestionTemplate
        description={<span className="font-normal">{description}</span>}
        title={pageTitle}
        options={options}
        onChange={handleChange}
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
        errorPath="canWeEmailYou"
        errorMessages={errorMessages}
      ></BinaryQuestionTemplate>
    </>
  );
};
